import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { StyledButton } from "../../../../../../shared/components/buttons/custom-button";
import CustomTable from "../../../../../../shared/components/table/custom-table";
import { ActionsMenu } from "../../../../../../shared/components/table/custom-actions";
import ActionsModalPopup, {
  ActionButtonConfig,
} from "../../../../../../shared/components/modals/action-popup";
import CustomStepper from "../../../../../../shared/components/stepper/steppers";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import {
  FloatingButtonContainer,
  InnerButton,
} from "../../../../../../shared/components/buttons/floating-button-container";
import FacilityInfoForm from "./facility-information";
import FacilityProcessInfo from "./facility-details";
import {
  FacilityFarmCapacityInformation,
  mapFacilityDetails,
  mapToFacilityDetailsDeteleSaveReq,
  mapToFacilityDetailsReq,
} from "../../../sc-models/facility-product-dto";
// import { SCAppConfig } from '../../../../../shared/app-configs/sc-app-config';
import { useApi } from "../../../../../../shared/hooks/useApi";
import useNotification from "../../../../../../shared/hooks/useNotification";
import { API_ROUTES } from "../../../../../../shared/app-configs/sc-app-config";
import { LoaderComponent } from "../../../../../../shared/components/loaders/page-loader";
import _ from "lodash";
import { useFormActions } from "../../../../../../shared/hooks/form-builder.hooks";
import AlertPopup from "../../../../../../shared/components/modals/alert-moadal";
import { Utills } from "../../../../../../shared/app-configs/utilit";
import RenderDetailPanel from "./render-detail-panel";
import {
  convertFacilityData,
  fetchFacilityDetails,
} from "./facility-setail-api";
import { useTransactionCertificateStore } from "../../../../../../store/transaction-certificates.store";
import FacilityFarmCapacityInfo from "./facility-farm-capacity";

interface FacilityInformation {
  isMainSite: string;
  facilityNo?: string;
  facilityType: string;
  facilityOsId:string;
  facilityProductionCapacity?: string;
  facilityAdditionalScopes:string;
  facilityFarmNoAnimals?: string;
  facilityTeId?: string;
  facilityStandard?: string[];
  facilityName: string;
  facilityAddress1: string;
  facilityAddress2?: string;
  facilityAddress3?: string;
  facilityAddedDate:string;
  facilityRemovedDate?:string;
  facilityLastAuditDate?:string;
  facilityPostcode: string;
  facilityTown: string;
  facilityCountryOrArea: string;
  facilityStateOrProvince: string;
  facilityCbOfIndependentlyCertifiedSubcontractor: string;
}
export interface FacilityProcessDetails {
  facilityProcessCategoryCode: string;
  facilityProcessCategoryCodeDescription: string;
  facilityProcessCategoryUserSpecificTerm:string;
}
interface FacilityState {
  facilityInfo: FacilityInformation;
  facilityProcessInformation: FacilityProcessDetails[];
  facilityFarmCapacityInformation:FacilityFarmCapacityInformation[];
}

const initFacilityInfo: FacilityInformation = {
  isMainSite: "Y",
  // facilityNo: "",
  facilityType: "",
  facilityAdditionalScopes: "",
  facilityOsId: "",
  facilityAddedDate: "",
  facilityLastAuditDate: "",
  facilityRemovedDate: "",
  facilityProductionCapacity: "",
  facilityFarmNoAnimals: "",
  facilityTeId: "",
  // brandNames: '',
  facilityStandard: [],
  facilityName: "",
  facilityAddress1: "",
  facilityAddress2: "",
  facilityAddress3: "",
  facilityPostcode: "",
  facilityTown: "",
  facilityCountryOrArea: "",
  facilityStateOrProvince: "",
  facilityCbOfIndependentlyCertifiedSubcontractor: "",
};

const initFacilityState: FacilityState = {
  facilityInfo: initFacilityInfo,
  facilityProcessInformation:  [],
  facilityFarmCapacityInformation:[]
};

interface ScopeCertifiedDetailsComponentProps {
  onNextTab: () => Promise<void>;
  scStatus?: boolean;
}

const ScopeCertifiedDetailsComponent: React.FC<
  ScopeCertifiedDetailsComponentProps
> = ({ onNextTab, scStatus }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [editingIndex, setEditingIndex] = useState<number>(-1);
  const [data, setData] = useState<FacilityState[]>([]);
  const [apiData, setAPIData] = useState<FacilityState[]>([]);
  const [mainFacility, setMainFacility] = useState<FacilityState | undefined>();
  const [tableData, setTableData] = useState<any[]>([]);
  const [facilityData, setFacilityData] =
    useState<FacilityState>(initFacilityState);
  const [isNextEnabled, setNextEnabled] = useState<boolean>(false);
  const [isDeleteOnly, setDeleteOnly] = useState(false);
  const { isRestrictPopUpSave } = useTransactionCertificateStore();
    const [isFarmSite,setIsFarmSite] = useState<boolean>(false);
  
  const navigate = useNavigate();
  const {
    apiData: shipmentData,
    loading,
    error,
    executeGet,
    setLoadingState,
    executePost,
    executeDelete,
  } = useApi();
  const { executeGet: executeNewGet, loading: loadingNewGet } = useApi();
  const { notify } = useNotification();
  const [getEditExistingFacilityDetails, setEditExistingFacilityDetails] =
    useState({
      index: -1,
      value: "",
    });
  const {
    getCurrentFormValues,
    getCurrentTableData,
    updateTableData,
    updateTableRowbyIndex,
    removeTableRowbyIndex,
    replaceTableDatas,
    updateField,
    setDeleteSave,
    setEditSave,
    resetFormValueByPage,
    getDeleteSave,
  } = useFormActions("sc-facilitydetails");
  const facilityInfoRef = useRef<any>(null);
  const facilityFarmCapacityInfoRef = useRef<any>(null);
  const rawMaterialRef = useRef<any>(null);
  const { formtype, SC_ID } = useParams();
  const hasCreateSC = formtype === "create-sc";
  const hasSubmitSC: boolean = formtype === "submited-sc";
  const isReadOnlyBasedOnStatus = hasSubmitSC || scStatus;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [popUpTitle, setPopUpTitle] = useState<string>("");
  const [popUpBtnName, setPopUpBtnName] = useState<string>("");
  const [facilityId, setFacilityId] = useState<string>("");
  // const [facilityNo, setFacilityNo] = useState<string>("");
  const [facilityTeId, setFacilityTeId] = useState<string>("");
  const [pendingSave, setPendingSave] = useState<any>(null);
  const [subsequentFacilityFlag, setSubsequentFacilityFlag] =
    useState<boolean>(false);
  const [scSubsequentFacilityButtonFlag, setScSubsequentFacilityButtonFlag] =
    useState<boolean>(false);
  const [scNoOfFarmsFlag, setScNoOfFarmsFlag] = useState<boolean>(false);
  const setZustandInitialState = (initialState?: any) => {
    //set zustand state inital values
    const defaultState = initialState ?? initFacilityState;
    Object.entries(defaultState?.facilityInfo).forEach(([key, value]) => {
      updateField(key, value);
    });
    updateField("facilityProcessDetails", defaultState.facilityProcessDetails);
  };
  const loadFormData = async () => {
    try {
      const response: any = await executeGet(API_ROUTES.GET_FACILITY_LIST_DETAILS_V4, {
        scId: SC_ID,
      });
      const result = mapFacilityDetails(response.data.response);
      setTableData(result);
      setAPIData(result);
      setMainFacility(
        result?.find(
          (facility) => facility?.facilityInfo?.facilityType === "MF"
        )
      );
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };

  useEffect(() => {
    if (SC_ID || !hasCreateSC) {
      loadFormData();
    } else {
      updateTableData([]);
    }
  }, [SC_ID]);

  const toggleDrawer = () => {
    if (drawerOpen) {
      resetForm();
      setFacilityData(initFacilityState);
      setZustandInitialState();
      setIsFarmSite(false);
      setFacilityId("");
      // setFacilityNo("");
      setEditingIndex(-1);
    }
    setActiveStep(0);
    setDrawerOpen((prev) => !prev);
  };

  const handleDataUpdate = (stepKey: keyof FacilityState, updatedData: any) => {
    setFacilityData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
  };
  const handleNext = async () => {
    const currentRef = (activeStep === 0) ? facilityInfoRef :(activeStep===1)?facilityFarmCapacityInfoRef: rawMaterialRef;
    Utills.cl("currentRef", currentRef);
    if (currentRef?.current ) {
      const errors = await currentRef.current.validateForm();
      Object.keys(errors).forEach((fieldName) => {
        currentRef.current.setFieldTouched(fieldName, true, false);
      });
      if (Object.keys(errors).length === 0) {
        currentRef.current.submitForm();
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
      } else {
        notify("Enter the mandatory fields", "error");
      }
    }else if (activeStep===1){
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));

    }
  };

  const handleBack = () => setActiveStep((prev) => Math.max(prev - 1, 0));
  Utills.cl(facilityData, "data", data);

  const handleFinish = async () => {
    if (facilityData.facilityProcessInformation.length <= 0) {
      notify("Please add atleast one facility process", "error");
      return;
    }
    if(isFarmSite && facilityData?.facilityFarmCapacityInformation?.length<1){
      notify("Please add facility farm capacity information", "error");
      return;
    }
    if (SC_ID) {
      // Find the existing record in tableData that matches the facilityId
      const existingRecord = tableData.find(
        (item) => item.facilityInfo.facilityId === facilityId
      );
      let payloadFacilityId: string | null = facilityId;
      if (
        existingRecord &&
        existingRecord.facilityInfo.facilityTeId !==
          facilityData?.facilityInfo?.facilityTeId
      ) {
        payloadFacilityId = null;
      }
      const payload = mapToFacilityDetailsReq(facilityData, SC_ID, facilityId);
      // Check if facilityNo exists and has changed
      if (facilityId) {
        // If record exists and facilityNo has changed, handle deletion
        if (
          existingRecord
          &&
          existingRecord.facilityInfo.facilityTeId !==
            payload.facilityTeId
        ) {
          const row = {
            original: {
              facilityInfo: {
                facilityTeId:payload?.facilityTeId,
                // facilityNo: payload.facilityNo,
                facilityId: facilityId,
              },
            },
          };

          onEditDelete(row);
          // The actual save will happen in handleConfirmSave after deletion
          setPendingSave(payload);
          return;
        }

        // If no changes to facility number, save directly
        handleSave(payload);
      } else if (!facilityId) {
        // This is a new facility, not an edit
        handleSave(payload);
      }
    }
  };

  const handleSave = async (payload: any) => {
    if (!SC_ID) {
      return;
    }
    let isSuccess = false;
    const queryParams = new URLSearchParams({
      scId: SC_ID,
    }).toString();

    const finalUrl = `${API_ROUTES.CREATE_FACILITY_DETAILS_V4}?${queryParams}`;

    const result: any = await executePost(finalUrl, payload);
    if (result.status === 200) {
      isSuccess = true;
      notify("Data Saved Successfully", "success");
      setFacilityId("");
      // setFacilityNo("");
      loadFormData();
      setFacilityData(initFacilityState);
      toggleDrawer();
      await onNextTab();
    } else {
      notify("Unable to Save", "error");
    }
    return isSuccess;
  };

  const handleConfirmSave = async () => {
    try {
      // If we have a pending save payload, save it now
      let isSaveSuccess: any = false;
      if (pendingSave) {
        delete pendingSave.facilityId;
        isSaveSuccess = await handleSave(pendingSave);
        setPendingSave(null); // Clear the pending save
      }
      if (!pendingSave || isSaveSuccess) {
        await executeDelete(`${API_ROUTES.DELETE_API_V4}`, {
          scId: SC_ID,
          facilityId: facilityId,
          facilityTeId: facilityTeId,
        });

        await loadFormData();

        // Close the dialog
        setDialogOpen(false);

        // Reset states
        setFacilityId("");
        setFacilityTeId("");
        if (pendingSave) {
          notify("Previous facility successfully deleted", "success");
        } else {
          notify("Successfully deleted", "success");
        }
      }
    } catch (error) {
      console.error("Error in handleConfirmSave:", error);
      notify("Failed to process the request", "error");
    }
  };

  const onNext = () => {
    if (
      apiData.filter(
        (facility) => facility?.facilityInfo?.facilityType === "MF"
      ).length == 0
    ) {
      notify("Please add atleast one Main Facility", "error");
    } else {
      navigate(`/v4/sc/${formtype}/facility-product-details/${SC_ID}`);
    }
  };

  const handleDeleteSaveData = async () => {
    try {
      if (SC_ID) {
        if (!isDeleteOnly && getDeleteSave()) {
          const userFilledValues = getCurrentFormValues();
          updateTableRowbyIndex(editingIndex, userFilledValues);
        } else if (isDeleteOnly && !getDeleteSave()) {
          removeTableRowbyIndex(editingIndex);
          const deletedData = data.filter((item, index) => {
            index !== editingIndex;
          });
          setData(deletedData);
          setEditingIndex(-1);
        }
        const facilityDetailsData: any = getCurrentTableData();
        setDeleteOnly(false);
        setDeleteSave(false);
        setEditSave(false);
        let isPostCreation = apiData?.length === 1 ? "no" : "yes";
        const facilityDetailsReq = mapToFacilityDetailsReq(
          data,
          SC_ID,
          isPostCreation
        );
        const result: any = await executePost(
          API_ROUTES.CREATE_FACILITY_DETAILS,
          facilityDetailsReq
        );
        if (result.status === 200) {
          notify("Saved Successfully", "success");
          // toggleDrawer()
          await loadFormData();
        } else {
          notify("Unable to Save", "error");
        }
      }
    } catch (error) {
      console.error("Error saving Facility Details:", error);
      notify("Error saving Facility Details", "error");
    }
  };
  const handleCancelSave = async () => {
    // Utills.cl("inside handleCancelSave", getDeleteSave())
    // if (!isDeleteOnly) {
    //   // toggleDrawer()
    // }
    // if (getEditExistingFacilityDetails.index != -1) {
    //   setEditExistingFacilityDetails({
    //     index: -1, value: ''
    //   })
    //   toggleDrawer()
    // }
    // setDeleteSave(false)
    // await loadFormData()
    setDialogOpen(false);
    if (drawerOpen) {
      toggleDrawer();
    }
  };
  const onEdit = (row: any) => {
    const value = row?.original;
    setFacilityId(value.facilityInfo.facilityId);
    setFacilityTeId(row?.original?.facilityInfo?.facilityTeId);
    // setFacilityNo(value.facilityInfo.facilityNo);
    if (SC_ID && value.facilityInfo.facilityId) {
      fetchFacilityDetails(executeNewGet, SC_ID, value.facilityInfo.facilityId)
        .then((data:any) => {
          const payload = convertFacilityData(data?.data);
          setFacilityData(payload);
          toggleDrawer();
        })
        .catch((err:any) => notify(err.message, "error"));
    }

    setEditingIndex(row.index);
    setZustandInitialState(value);
  };

  const onDelete = (row: any) => {
    setFacilityId(row?.original?.facilityInfo.facilityId);
    // setFacilityNo(row?.original?.facilityInfo.facilityNo);
    setFacilityTeId(row?.original?.facilityInfo?.facilityTeId);
    setDialogOpen(true);
    setPopUpBtnName("Delete");
    setPopUpTitle("Confirm Delete ?");
    setPopUpMessage(
      `Deleting a Facility will remove all the Associated Records, are you sure want to delete it`
    );
  };

  const onEditDelete = (row: any) => {
    setFacilityId(row?.original?.facilityInfo.facilityId);
    setFacilityTeId(row?.original?.facilityInfo?.facilityTeId);
    // setFacilityNo(row?.original?.facilityInfo.facilityNo);
    setDialogOpen(true);
    setPopUpBtnName("Save");
    setPopUpTitle("Confirm Save ?");
    setPopUpMessage(
      `Editing a Facility No. will remove all the Associated Facility Products, are you sure want to edit it`
    );
  };

  const resetForm = () => {
    setZustandInitialState(initFacilityState);
  };
  const steps = [
    {
      label: "Facility Information",
      content: (
        <FacilityInfoForm
          formRef={facilityInfoRef}
          facilityData={facilityData.facilityInfo}
          mainSite={mainFacility}
          mfExists={
            apiData.length > 0 &&
            apiData.filter(
              (facility) => facility?.facilityInfo?.facilityType === "MF"
            ).length > 0
          }
          processCodes={facilityData.facilityProcessInformation?.map((process)=>process?.facilityProcessCategoryCode)}
          setFacilityData={(data:any) => handleDataUpdate("facilityInfo", data)}
          setSubsequentFacilityFlag={setSubsequentFacilityFlag}
          subsequentFacilityFlag={subsequentFacilityFlag}
          setScSubsequentFacilityButtonFlag={setScSubsequentFacilityButtonFlag}
          // scNoOfFarmsFlag={scNoOfFarmsFlag}
          // setScNoOfFarmsFlag={setScNoOfFarmsFlag}
          scSubsequentFacilityButtonFlag={scSubsequentFacilityButtonFlag}
          facilityInfoData={facilityData.facilityProcessInformation}
        />
      ),
    },
    {
      label: "Facility Process Details",
      content: (
        <FacilityProcessInfo
          // formRef={rawMaterialRef}
          facilityData={facilityData.facilityInfo}
          facilityProcessInfo={facilityData.facilityProcessInformation}
          setFacilityProcessInfo={(data:any) =>
            handleDataUpdate("facilityProcessInformation", data)
          }
          setIsFarmSite={setIsFarmSite}
          isFarmSite={isFarmSite}
          subsequentFacilityFlag={subsequentFacilityFlag}
          setSubsequentFacilityFlag={setSubsequentFacilityFlag}
          scSubsequentFacilityButtonFlag={scSubsequentFacilityButtonFlag}
          setScSubsequentFacilityButtonFlag={setScSubsequentFacilityButtonFlag}
          scNoOfFarmsFlag={scNoOfFarmsFlag}
          setScNoOfFarmsFlag={setScNoOfFarmsFlag}
        />
      ),
    },
    ...isFarmSite?[{
      label: "Facility Farm Capacity Information",
      content: (
        <FacilityFarmCapacityInfo
          formRef={facilityFarmCapacityInfoRef}
          facilityData={facilityData.facilityInfo}
          facilityFarmCapacityInfo={facilityData.facilityFarmCapacityInformation}
          setFacilityFarmCapacityInfo={(data:any) =>
            handleDataUpdate("facilityFarmCapacityInformation", data)
          }
        />
      ),
    }]:[],
  ];

  const actions: ActionButtonConfig[] = [
    ...activeStep!==0?[{
      label: "Back",
      onClick: handleBack,
      variant: "contained" as "contained",
      color: "default" as const,
      disabled: activeStep === 0,
    }]:[],
    {
      label: activeStep === steps.length - 1 ? "Save" : "Next",
      onClick: activeStep === steps.length - 1 ? handleFinish : handleNext,
      variant: "contained",
      color: "primary",
      disabled: ((activeStep === 1||activeStep === 2) && isRestrictPopUpSave) ||
        ((activeStep === 2||activeStep === 1) && !scSubsequentFacilityButtonFlag),
    },
  ];

  const columns: MRT_ColumnDef<FacilityInformation>[] = [
    // {
    //   accessorKey: "facilityInfo.facilityNo",
    //   header: "Facility No.",
    //   minSize: 60,
    //   maxSize: 150,
    // },
    {
      accessorKey: "facilityInfo.facilityType",
      header: "Facility Type",
      minSize: 60,
      maxSize: 150,
    },
    // {
    //   accessorKey: "facilityInfo.facilityOarId",
    //   header: "OAR ID",
    //   minSize: 60,
    //   maxSize: 150,
    // },
    {
      accessorKey: "facilityInfo.facilityTeId",
      header: "Facility TE-ID",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityName",
      header: "Facility Name",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityPostcode",
      header: "Postcode",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityCountryOrArea",
      header: "Country/Area",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityAddedDate",
      header: "Facility Added Date",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "facilityInfo.facilityRemovedDate",
      header: "Facility Removed Date",
      minSize: 60,
      maxSize: 150,
    },
  ];
  console.log(tableData);
  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
            {!isReadOnlyBasedOnStatus && (
              <StyledButton
                variant="contained"
                onClick={() => {
                  if (
                    apiData?.length === 0 ||
                    apiData.filter(
                      (facility) =>
                        facility?.facilityInfo?.facilityType === "MF"
                    ).length == 0
                  ) {
                    setFacilityData({
                      ...initFacilityState,
                      facilityInfo: {
                        ...initFacilityInfo,
                        facilityType: "MF",
                      },
                    });
                  }
                  toggleDrawer();
                }}
              >
                Add New Facility
              </StyledButton>
            )}
          </Box>
          <Box display="grid">
            <CustomTable
              columns={columns}
              data={tableData}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enableRowActions={!isReadOnlyBasedOnStatus}
              renderDetailPanel={({ row }:any) =>
                // Only mount the detail panel if the row is expanded
                row.getIsExpanded() ? (
                  <RenderDetailPanel row={row} />
                ) : (
                  <>No data</>
                )
              }
              renderRowActions={({ row }:any) => (
                <ActionsMenu row={row} onEdit={onEdit} onDelete={onDelete} />
              )}
            />
          </Box>
          <ActionsModalPopup
            open={drawerOpen}
            onClose={toggleDrawer}
            title="Add Facility"
            actions={actions}
          >
            <CustomStepper
              steps={steps}
              activeStep={activeStep}
              onStepChange={(step:any) => setActiveStep(step)}
            />
          </ActionsModalPopup>
          {tableData.length > 0 && !drawerOpen && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap:"0.5rem" }}>
              {/* <InnerButton onClick={handleSave}>Save & Next</InnerButton> */}
              <NavLink to="/sc-dashboard">
                <InnerButton>Home</InnerButton>
              </NavLink>
              <InnerButton onClick={onNext}>Next</InnerButton>
            </Box>
          )}
          <AlertPopup
            open={dialogOpen}
            title={popUpTitle}
            message={popUpMessage}
            onClose={handleCancelSave}
            onConfirm={handleConfirmSave}
            confirmText={popUpBtnName}
            cancelText="Cancel"
          />
        </>
      )}
    </>
  );
};

export default ScopeCertifiedDetailsComponent;
